import type { ReactElement } from "react";
import { StatusDot, Popover } from "orcs-design-system";
import { principleStatusText } from "src/components/PrincipleStatus";

type NotificationDotProps = {
  met?: string | undefined;
  detail?: string | undefined;
  ruleDetail?: string | undefined;
};

const NotificationDot = ({ met, detail, ruleDetail }: NotificationDotProps) => {
  if (!met) {
    return null;
  }

  let Dot: ReactElement | null = null;

  if (met === "TRUE") {
    Dot = <StatusDot variant="success" />;
  } else if (met === "FALSE") {
    Dot = <StatusDot variant="danger" />;
  }

  if (!detail) {
    return Dot;
  }

  return (
    <Popover
      key={detail}
      direction="right"
      text={principleStatusText(
        {
          title: detail,
          met,
          ruleDetail,
        },
        true
      )}
      textAlign="left"
      width="300px"
    >
      {Dot}
    </Popover>
  );
};

export default NotificationDot;
